var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecipent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1196 1H1.3806C1.17042 1 1 1.17015 1 1.38V19.62C1 19.7208 1.0401 19.8175 1.11146 19.8887C1.18282 19.96 1.27967 20 1.3806 20H16.1196C16.2205 20 16.3173 19.96 16.3887 19.8887C16.4601 19.8175 16.5002 19.7208 16.5002 19.62V1.38C16.5002 1.27923 16.4601 1.18253 16.3887 1.11129C16.3173 1.04004 16.2205 1 16.1196 1ZM15.739 19.24H1.76119V1.76H15.739V19.24Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4932 4.97015H13.0069C13.2134 4.97015 13.3807 4.77968 13.3807 4.54478C13.3807 4.30988 13.2134 4.11941 13.0069 4.11941H4.4932C4.28677 4.11941 4.11938 4.30988 4.11938 4.54478C4.11938 4.77968 4.28677 4.97015 4.4932 4.97015Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4932 7.80597H13.0069C13.2134 7.80597 13.3807 7.6155 13.3807 7.3806C13.3807 7.14569 13.2134 6.95522 13.0069 6.95522H4.4932C4.28677 6.95522 4.11938 7.14569 4.11938 7.3806C4.11938 7.6155 4.28677 7.80597 4.4932 7.80597Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4932 10.6418H13.0069C13.2134 10.6418 13.3807 10.4513 13.3807 10.2164C13.3807 9.98151 13.2134 9.79104 13.0069 9.79104H4.4932C4.28677 9.79104 4.11938 9.98151 4.11938 10.2164C4.11938 10.4513 4.28677 10.6418 4.4932 10.6418Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39066 16.3134H13.007C13.2134 16.3134 13.3808 16.123 13.3808 15.8881C13.3808 15.6532 13.2134 15.4627 13.007 15.4627H8.39066C8.18423 15.4627 8.01685 15.6532 8.01685 15.8881C8.01685 16.123 8.18423 16.3134 8.39066 16.3134Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipent);
export default __webpack_public_path__ + "static/media/recipent.10e62fbab87ee8193d22a36bd22bcf52.svg";
export { ForwardRef as ReactComponent };